import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tabs-container" }
const _hoisted_2 = {
  key: 0,
  class: "tab-conent"
}
const _hoisted_3 = {
  key: 1,
  class: "tab-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxTabs = _resolveComponent("DxTabs")!
  const _component_Users = _resolveComponent("Users")!
  const _component_GridRoluri = _resolveComponent("GridRoluri")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_GridRoluriUtilizatori = _resolveComponent("GridRoluriUtilizatori")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxTabs, {
      "data-source": $data.tabs,
      class: "tabs",
      "selected-index": $data.selectedIndex,
      onOptionChanged: $options.onTabChanged,
      "item-template": $options.tabTemplate
    }, null, 8, ["data-source", "selected-index", "onOptionChanged", "item-template"]),
    ($data.selectedIndex === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Users)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_GridRoluri, { onSelectionChanged: $options.handleSelectionChanged }, null, 8, ["onSelectionChanged"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_GridRoluriUtilizatori, { RolID: $data.selectedRow }, null, 8, ["RolID"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}